import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { gettext } from "@eb/i18n";

import { Button, SIZE_BLOCK, STYLE_LINK } from '@eb/eds-button';
import { Icon } from '@eb/eds-icon';
import { LogoGoogle } from '@eb/eds-iconography';

import { SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE } from './constants';
import { injectScriptTag } from './utils';

import './GoogleLoginButton.scss';

export default class GoogleLoginButton extends Component {
    static propTypes = {
        onSocialConnectVerified: PropTypes.func,
        onSocialConnectNotAuthorized: PropTypes.func,
        onLoadComplete: PropTypes.func,
        onClick: PropTypes.func,
    };

    componentDidMount() {
        const { asyncStrategy, skipScriptLoading } = this.props;

        if (!skipScriptLoading) {
            injectScriptTag({
                doc: document,
                id: 'google-id-auth',
                src: 'https://apis.google.com/js/platform.js',
                asyncStrategy,
                onLoad: this.googleInit,
            });
        }
    }

    /* istanbul ignore next */
    googleInit = () => {
        const { clientId, scope, skipScriptLoading } = this.props;

        /*eslint-disable no-undef*/
        if (window.gapi && !skipScriptLoading) {
            gapi.load('auth2', function () {
                gapi.auth2 &&
                    gapi.auth2.init({
                        client_id: clientId,
                        scope: scope,
                    });
            });
        }
    };

    // signOut = () => {
    //     /*eslint-disable no-undef*/
    //     if (gapi) {
    //         const auth2 = gapi.auth2 && gapi.auth2.getAuthInstance();

    //         auth2.signOut().then(function () {
    //             console.log('User signed out.');
    //         });
    //     }
    // };

    handleOnClick = () => {
        const {
            onSocialConnectVerified,
            onSocialConnectNotAuthorized,
            onSocialLogInUserAuthorized,
            onClick,
        } = this.props;
        onClick?.(SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE);

        /* istanbul ignore next */
        /*eslint-disable no-undef*/
        if (window.gapi) {
            const auth2 = gapi.auth2 && gapi.auth2.getAuthInstance();
            gapi.load('auth2', function () {
                auth2.signIn().then(
                    (googleUser) => {
                        if (!isEmpty(googleUser)) {
                            if (auth2.isSignedIn.get() == true) {
                                onSocialLogInUserAuthorized?.(
                                    SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE,
                                    googleUser,
                                );
                                onSocialConnectVerified?.(
                                    SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE,
                                    {
                                        accessToken: googleUser.getAuthResponse()
                                            .id_token,
                                        email: googleUser
                                            .getBasicProfile()
                                            .getEmail(),
                                        firstName: googleUser
                                            .getBasicProfile()
                                            .getGivenName(),
                                        lastName: googleUser
                                            .getBasicProfile()
                                            .getFamilyName(),
                                        picture: googleUser
                                            .getBasicProfile()
                                            .getImageUrl(),
                                        userID: googleUser
                                            .getBasicProfile()
                                            .getId(),
                                        sourceProvider: SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE,
                                    },
                                );
                            } else {
                                onSocialConnectNotAuthorized?.(
                                    SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE,
                                    {
                                        sourceProvider: SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE,
                                        status: googleUser,
                                    },
                                );
                            }
                        }
                    },
                    function (status) {
                        onSocialConnectNotAuthorized?.(
                            SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE,
                            {
                                sourceProvider: SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE,
                                status,
                            },
                        );
                    },
                );
            });
        }
    };

    render() {
        const { buttonGoogleText } = this.props;
        const buttonText =
            buttonGoogleText || gettext('Continue with Google');

        return (
            <div className="google-login__container">
                <Button
                    type="button"
                    size={SIZE_BLOCK}
                    onClick={this.handleOnClick}
                    style={STYLE_LINK}
                >
                    <div className="google-login__icon">
                        <Icon type={<LogoGoogle />} size="small" />
                    </div>
                    {buttonText}
                </Button>
            </div>
        );
    }
}
